export const CUSTOMER_TYPES = [
  { key: "bayi", label: "Bayi", tone: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { key: "nokta", label: "Nokta", tone: "bg-amber-50 text-amber-700 border-amber-200" },
  { key: "nihai_tuketici", label: "Nihai Tüketici", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { key: "internet", label: "İnternet", tone: "bg-sky-50 text-sky-700 border-sky-200" },
];

export const typeOf = (key) => CUSTOMER_TYPES.find((t) => t.key === key);

export const EMPTY_CUSTOMER = {
  legal_name: "", customer_type: "", billing_address: "", contact_name: "", phone: "",
  email: "", telegram_username: "", default_payment_days: "", notes: "", active: true,
};

export function apiError(e, fallback = "İşlem başarısız") {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => (x.msg || "").replace(/^Value error, /, "")).join(" · ");
  return d || fallback;
}
